import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "phone" ]

  copy(){
    navigator.clipboard.writeText(this.phoneTarget.value);
    alert('Número copiado para a sua área de transferência(clipboard).');
  }
}